<template>
  <div>
    <NSeparator separator="solid" label="Solid" />
    <NSeparator separator="dashed" label="Dashed" />
    <NSeparator separator="dotted" label="Dotted" />
  </div>
</template>
